import React, { useState, useEffect, useRef, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, Row, Col } from "react-bootstrap";
import { Tooltip } from "react-tooltip"; // or use any tooltip library you like
import AsyncSelect from "react-select/async";
import { FaSearch } from "react-icons/fa";

import {
  MdAdd,
  MdDelete,
  MdVisibility,
  MdVisibilityOff,
  MdContentCopy,
  MdRefresh,
  MdVerified,
} from "react-icons/md";
import { CiCircleRemove } from "react-icons/ci";
import "../../styles/InputSheet.css";
import "../Profile/ReactSelect.css";
import "../../styles/FileUpload.css";
import { MdModeEditOutline } from "react-icons/md";
import { GoUnverified } from "react-icons/go";

import {
  FiPlusCircle,
  FiMinusCircle,
  FiUploadCloud,
  FiInfo,
} from "react-icons/fi";
import {
  addOemPartner,
  getOemPartners,
  editOemPartner,
  deleteOemPartner,
  changeOemStatus,
  getScanTypes,
  getLicenses,
  getLicensesList,
} from "../../redux/actions/oemActions";
import { getCountries } from "../../redux/actions/countryActions";
import { toast } from "react-toastify";
import PlansDetails from "./common/PlansDetails";
import OEMPartnerTable from "./common/OEMPartnerTable";
import OEMResetPasswordModal from "./common/OEMResetPasswordModal";
import OEMDetailsOffcanvas from "../../helper/OEMDetailsOffcanvas";
import LogoPreviewModal from "../../components/modal/LogoPreviewModal";
import StatusConfirmModal from "../../components/modal/StatusConfirmModal";
import DeleteConfirmModal from "../../components/modal/DeleteConfirmModal";
import InactiveEditModal from "../../components/modal/InactiveEditModal";

import {
  getPhoneValidationRules,
  validatePhoneNumber,
} from "../../utils/phoneValidation";
import { LiaCheckDoubleSolid } from "react-icons/lia";
import { handleCopyClick } from "../../commonServices/copyService";
import CopyToast from "../../commonServices/CopyToast";

const OEMPartners = () => {
  const dispatch = useDispatch();
  const token = sessionStorage?.getItem("authToken");
  const {
    partners = [],
    scanTypes = [],
    licenses = [],
    licensesList = [],
    loading = false,
    formLoading = false,
    error = null,
    pagination = {},
  } = useSelector((state) => state.oem || {});
  const { countries = [] } = useSelector((state) => state.country || {});
  const [currentPage, setCurrentPage] = useState(1);
  const {
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
    register,
    watch,
    control,
    setValue,
  } = useForm({
    defaultValues: {
      scanTypeId: "",
      companyName: "",
      email: "",
      firstName: "",
      lastName: "",
      contactNumber: "",
      logo: null,
      country: "",
      currency: "",
      status: "active",
      almataSharedDiscription: "",
      stripeLicenseKeyId: "",
      domainName: "",
      stripeProductId: [""],
      planDetails: [
        {
          stripeProductId: "",
          amount: "",
          planName: "",
          couponDetails: "",
        },
      ],
      oemUrl: "",
    },
  });

  const [showInputForm, setShowInputForm] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [copiedId, setCopiedId] = useState(null);
  const [copiedUrl, setCopiedUrl] = useState(null);
  const [editingPartner, setEditingPartner] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    partner: null,
  });
  const [statusModal, setStatusModal] = useState({
    isOpen: false,
    partner: null,
    newStatus: null,
  });
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    // Prevent leading spaces but allow spaces after text
    if (value.length === 0 || (value.length > 0 && value[0] !== " ")) {
      setSearchTerm(value);
    } else if (searchTerm.length > 0) {
      // Allow spaces if there's already text
      setSearchTerm(value);
    }
  };
  const [statusFilter, setStatusFilter] = useState("active");

  const [descriptionWordCount, setDescriptionWordCount] = useState(0);
  const [inactiveEditModal, setInactiveEditModal] = useState({
    isOpen: false,
    partner: null,
  });
  const [isPasswordResetting, setIsPasswordResetting] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const passwordResetRef = useRef(false);
  const [passwordResetModal, setPasswordResetModal] = useState({
    isOpen: false,
    currentPassword: "",
  });
  const [stripeProductId, setStripeProductId] = useState([""]);
  const [planDetails, setPlanDetails] = useState([
    {
      stripeProductId: "",
      amount: "",
      planName: "",
      couponDetails: "",
    },
  ]);
  const [logoPreviewModal, setLogoPreviewModal] = useState({
    isOpen: false,
    imageUrl: "",
    imageName: "",
  });
  const [detailsOffcanvas, setDetailsOffcanvas] = useState({
    isOpen: false,
    partner: null,
  });

  const [flagLink, setFlagLink] = useState("us");
  const [countryCode, setCountryCode] = useState("+1");
  const [phoneCountry, setPhoneCountry] = useState("United States");

  const contactNumber = watch("contactNumber");

  const logoFile = watch("logo");
  const selectedCountry = watch("country");
  const almataDescription = watch("almataSharedDiscription");

  useEffect(() => {
    if (almataDescription) {
      const words = almataDescription
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0);
      setDescriptionWordCount(words.length);
    } else {
      setDescriptionWordCount(0);
    }
  }, [almataDescription]);

  const loadCountryOptions = useCallback(async (inputValue) => {
    if (inputValue) {
      dispatch(getCountries(inputValue));
    }
    return countries.slice(0, 10).map((country) => ({
      value: country.name,
      label: country.name,
      currencies: { [country.currency]: {} },
      isoCode: country.isoCode,
      countryCode: country.countryCode,
    }));
  }, [countries, dispatch]);

  const handleCountryChange = (selectedOption, { action }) => {
    if (action === "clear") {
      setValue("country", "");
      setValue("currency", "");
      return null;
    }
    setValue("country", selectedOption?.value || "");
    setValue("currency", selectedOption?.currencies ? Object.keys(selectedOption.currencies)[0] : "USD");
    return selectedOption;
  };

  const handlePhoneCountryChange = (selectedOption, { action }) => {
    if (action === "clear") {
      setFlagLink("us");
      setCountryCode("+1");
      setPhoneCountry("United States");
      return null;
    }

    if (selectedOption) {
      setFlagLink(selectedOption.isoCode || "us");
      setCountryCode(selectedOption.countryCode || "+1");
      setPhoneCountry(selectedOption.value || "United States");
      setValue("contactNumber", "");
    }

    return selectedOption;
  };

  const { user } = useSelector((state) => state.auth);
  const itSalesPartnerId = user?.itSalesPartner?.id;

  useEffect(() => {
    if (itSalesPartnerId) {
      dispatch(
        getOemPartners({
          limit: 10,
          page: currentPage,
          search: searchTerm,
          status: statusFilter,
          _id: itSalesPartnerId,
        }),
      );
    }
    dispatch(getScanTypes());
    dispatch(getLicensesList({ search: "" }));
    dispatch(getCountries(""));
  }, [dispatch, currentPage, searchTerm, statusFilter, itSalesPartnerId]);

  // Set default License scan type when scanTypes are loaded
  useEffect(() => {
    if (scanTypes.length > 0 && !editingPartner) {
      const licenseScanType = scanTypes.find((type) => type.name === "License");
      if (licenseScanType) {
        setValue("scanTypeId", licenseScanType._id);
      }
    }
  }, [scanTypes, editingPartner, setValue]);

  const loadLicenseOptions = useCallback(
    async (inputValue) => {
      return (Array.isArray(licensesList) ? licensesList : [])
        .filter((license) => {
          // Filter by search input
          const matchesSearch =
            !inputValue ||
            license.name?.toLowerCase().includes(inputValue.toLowerCase());

          return matchesSearch;
        })
        .slice(0, 10)
        .map((license) => ({
          value: license._id,
          label: license.name,
        }));
    },
    [licensesList],
  );

  const handleLicenseChange = (selectedOption, { action }) => {
    if (action === "clear") {
      setValue("stripeLicenseKeyId", "");
      return null;
    }
    setValue("stripeLicenseKeyId", selectedOption?.value || "");
    return selectedOption;
  };

  // Set default US country when not editing
  useEffect(() => {
    if (!editingPartner && !watch("country")) {
      setValue("country", "United States");
      setValue("currency", "USD");
    }
    if (!editingPartner) {
      setFlagLink("us");
      setCountryCode("+1");
      setPhoneCountry("United States");
    }
  }, [editingPartner, setValue, watch]);

  const onSubmit = (data) => {
    // Check if creating new OEM and no licenses available
    if (!editingPartner && licensesList.length === 0) {
      toast.error(
        "No license keys available. Please contact administrator to acquire more keys",
        {
          pauseOnHover: true,
        },
      );
      return;
    }

    const payload = {
      companyName: data.companyName,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      contactNumber: data.contactNumber,
      country: data.country,
      currency: data.currency,
      almataSharedDiscription: data.almataSharedDiscription,
      scanTypeId: data.scanTypeId,
      createdBy: itSalesPartnerId,
      createdByModel: "itsalespartner",
      countryCode,
      licenseId: data.stripeLicenseKeyId || "",
      domainName: data.domainName || "",
      refreshParams: {
        limit: 10,
        page: currentPage,
        search: searchTerm,
        status: statusFilter,
        _id: itSalesPartnerId,
      },
    };

    // Add logo file if selected
    if (selectedFile) {
      payload.logo = selectedFile;
    }

    if (editingPartner) {
      payload.status = data.status;
      if (resetPassword) {
        payload.resetPassword = true;
      }
      dispatch(editOemPartner({ _id: editingPartner._id, ...payload }));
    } else {
      dispatch(addOemPartner(payload));
    }
  };

  const { success } = useSelector((state) => state.oem || {});

  useEffect(() => {
    if (success && !formLoading && !passwordResetRef.current) {
      dispatch(getLicensesList({ search: "" }));

      reset({
        companyName: "",
        email: "",
        firstName: "",
        lastName: "",
        contactNumber: "",
        logo: null,
        country: "",
        currency: "",
        status: "active",
        almataSharedDiscription: "",
        stripeLicenseKeyId: "",
        domainName: "",
        stripeProductId: [""],
        planDetails: [
          {
            stripeProductId: "",
            amount: "",
            planName: "",
            couponDetails: "",
          },
        ],
        oemUrl: "",
      });
      setSelectedFileName("");
      setSelectedFile(null);
      setEditingPartner(null);
      setResetPassword(false);
      setStripeProductId([""]);
      setPlanDetails([
        {
          stripeProductId: "",
          amount: "",
          planName: "",
          couponDetails: "",
        },
      ]);
    }
  }, [success, formLoading, reset, dispatch]);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setSelectedFileName(file.name);
    } else {
      setSelectedFile(null);
      setSelectedFileName("");
    }
  };

  const removePartner = (partner) => {
    setDeleteModal({ isOpen: true, partner });
  };
  const handleDeleteConfirm = () => {
    dispatch(
      deleteOemPartner({
        id: deleteModal.partner._id,
        refreshParams: {
          limit: 10,
          page: currentPage,
          search: searchTerm,
          status: statusFilter,
          _id: itSalesPartnerId,
        },
      }),
    );
    setDeleteModal({ isOpen: false, partner: null });
  };

  const handleDeleteCancel = () => {
    setDeleteModal({ isOpen: false, partner: null });
  };

  const handleStatusChange = (partner) => {
    const newStatus = partner.status === "active" ? "inactive" : "active";
    setStatusModal({ isOpen: true, partner, newStatus });
  };

  const handleStatusConfirm = () => {
    dispatch(
      changeOemStatus({
        oemId: statusModal.partner._id,
        status: statusModal.newStatus,
        refreshParams: {
          limit: 10,
          page: currentPage,
          search: searchTerm,
          status: statusFilter,
          _id: itSalesPartnerId,
        },
      }),
    );
    setStatusModal({ isOpen: false, partner: null, newStatus: null });
  };

  const handleStatusCancel = () => {
    setStatusModal({ isOpen: false, partner: null, newStatus: null });
  };

  const handleEditClick = async (partner) => {
    if (partner.status === "inactive") {
      setInactiveEditModal({ isOpen: true, partner });
    } else {
      const freshPartner =
        partners.find((p) => p._id === partner._id) || partner;
      setEditingPartner(freshPartner);
      const { plainPassword, token, tokenExpire, ...partnerData } =
        freshPartner;
      reset({
        ...partnerData,
        oemUrl: freshPartner.oemUrl || "",
      });
      setValue("plainPassword", plainPassword || "");
      setShowInputForm(true);
      setResetPassword(false);

      // Set flag and country code for existing partner
      if (partner.countryCode && partner.flagLink) {
        setCountryCode(partner.countryCode);
        const isoCode = partner.flagLink.split("/").pop().split(".")[0];
        setFlagLink(isoCode);
        setPhoneCountry(partner.phoneCountry || "United States");
      } else {
        setFlagLink("us");
        setCountryCode("+1");
        setPhoneCountry("United States");
      }

      if (partner.country) {
        const countryData = countries.find(c => c.name === partner.country);
        if (countryData) {
          setFlagLink(countryData.isoCode || "us");
          setCountryCode(countryData.countryCode || "+1");
        } else {
          setFlagLink("us");
          setCountryCode("+1");
        }
      } else {
        setFlagLink("us");
        setCountryCode("+1");
      }

      // Ensure oemUrl is set
      setValue("oemUrl", partner.oemUrl || "");

      // Handle licenseId - map to stripeLicenseKeyId form field
      if (partner.licenseId) {
        const licenseValue =
          typeof partner.licenseId === "object"
            ? partner.licenseId._id
            : partner.licenseId;
        setValue("stripeLicenseKeyId", licenseValue);
      }

      setStripeProductId(
        Array.isArray(partner.stripeProductId) ? partner.stripeProductId : [""],
      );
      setPlanDetails(
        partner.planDetails &&
          Array.isArray(partner.planDetails) &&
          partner.planDetails.length > 0
          ? partner.planDetails.map((plan) => ({
              stripeProductId: plan.stripeProductId || "",
              amount: plan.amount || "",
              planName: plan.planName || "",
              couponDetails: plan.couponDetails || "",
              currency: plan.currency || partner.currency || "USD",
            }))
          : [
              {
                stripeProductId: "",
                amount: "",
                planName: "",
                couponDetails: "",
              },
            ],
      );
    }
  };

  const handleInactiveEditClose = async () => {
    const partner = inactiveEditModal.partner;
    setInactiveEditModal({ isOpen: false, partner: null });
    if (partner) {
      setEditingPartner(partner);
      const { plainPassword, token, tokenExpire, ...partnerData } = partner;
      reset({
        ...partnerData,
        oemUrl: partner.oemUrl || "",
      });
      setValue("plainPassword", plainPassword || "");
      setShowInputForm(true);
      setResetPassword(false);

      // Set flag and country code for existing partner
      if (partner.countryCode && partner.flagLink) {
        setCountryCode(partner.countryCode);
        const isoCode = partner.flagLink.split("/").pop().split(".")[0];
        setFlagLink(isoCode);
        setPhoneCountry(partner.phoneCountry || "United States");
      } else {
        setFlagLink("us");
        setCountryCode("+1");
        setPhoneCountry("United States");
      }

      if (partner.country) {
        const countryData = countries.find(c => c.name === partner.country);
        if (countryData) {
          setFlagLink(countryData.isoCode || "us");
          setCountryCode(countryData.countryCode || "+1");
        } else {
          setFlagLink("us");
          setCountryCode("+1");
        }
      } else {
        setFlagLink("us");
        setCountryCode("+1");
      }

      // Ensure oemUrl is set
      setValue("oemUrl", partner.oemUrl || "");

      // Handle licenseId - map to stripeLicenseKeyId form field
      if (partner.licenseId) {
        const licenseValue =
          typeof partner.licenseId === "object"
            ? partner.licenseId._id
            : partner.licenseId;
        setValue("stripeLicenseKeyId", licenseValue);
      }

      setStripeProductId(
        Array.isArray(partner.stripeProductId) ? partner.stripeProductId : [""],
      );
      setPlanDetails(
        partner.planDetails &&
          Array.isArray(partner.planDetails) &&
          partner.planDetails.length > 0
          ? partner.planDetails.map((plan) => ({
              stripeProductId: plan.stripeProductId || "",
              amount: plan.amount || "",
              planName: plan.planName || "",
              couponDetails: plan.couponDetails || "",
              currency: plan.currency || partner.currency || "USD",
            }))
          : [
              {
                stripeProductId: "",
                amount: "",
                planName: "",
                couponDetails: "",
              },
            ],
      );
    }
  };

  const handlePasswordResetClick = () => {
    passwordResetRef.current = true;
    const currentPasswordValue =
      watch("plainPassword") || editingPartner?.plainPassword || "";
    setPasswordResetModal({
      isOpen: true,
      currentPassword: currentPasswordValue,
    });
  };

  const handlePasswordResetSave = (newPassword) => {
    setValue("plainPassword", newPassword);
    if (editingPartner) {
      setEditingPartner((prev) => ({
        ...prev,
        plainPassword: newPassword,
      }));
    }
  };

  // Close password reset modal after successful password reset
  useEffect(() => {
    if (success && !loading && passwordResetModal.isOpen) {
      setPasswordResetModal({ isOpen: false, currentPassword: "" });
      setTimeout(() => {
        passwordResetRef.current = false;
      }, 2000);
    }
  }, [success, loading, passwordResetModal.isOpen]);

  const handlePasswordResetClose = () => {
    setPasswordResetModal({ isOpen: false, currentPassword: "" });
  };

  const handleLogoPreview = () => {
    let imageUrl = "";
    let imageName = "";

    if (selectedFile) {
      imageUrl = URL.createObjectURL(selectedFile);
      imageName = selectedFile.name;
    } else if (editingPartner?.logo) {
      imageUrl = editingPartner.logo;
      imageName = editingPartner.logo.split("/").pop();
    }

    setLogoPreviewModal({
      isOpen: true,
      imageUrl,
      imageName,
    });
  };

  const handleLogoPreviewClose = () => {
    setLogoPreviewModal({
      isOpen: false,
      imageUrl: "",
      imageName: "",
    });
  };

  const handleViewDetails = (partner) => {
    setDetailsOffcanvas({
      isOpen: true,
      partner,
    });
  };

  const handleDetailsOffcanvasClose = () => {
    setDetailsOffcanvas({
      isOpen: false,
      partner: null,
    });
  };
  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div className="form-header">
          <h2>OEM Partners Management</h2>
          <div
            onClick={() => setShowInputForm(!showInputForm)}
            className="cursor-pointer info_pointer toggle-btn fs-5 fw-bolder"
            title={showInputForm ? "Hide Input Form" : "Show Input Form"}
          >
            {showInputForm ? <FiMinusCircle /> : <FiPlusCircle />}
          </div>
        </div>
        {showInputForm && (
          <div className="input-form-section">
            <form onSubmit={handleSubmit(onSubmit)} className="input-form">
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Scan Type <span className="text-danger">*</span>
                  </label>
                  <select
                    {...register("scanTypeId", {
                      required: "Scan type is required",
                    })}
                    className={`form-input ${errors.scanTypeId ? "error" : ""}`}
                    disabled={true}
                    style={{
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    {scanTypes.map((scanType) => (
                      <option key={scanType._id} value={scanType._id}>
                        {scanType.name} Scan
                      </option>
                    ))}
                  </select>
                  {errors.scanTypeId && (
                    <span className="error-text">
                      {errors.scanTypeId.message}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <input
                    {...register("companyName", {
                      required: "Company name is required",
                      validate: (value) =>
                        value.trim() !== "" || "Company name is required",
                    })}
                    className={`form-input ${
                      errors.companyName ? "error" : ""
                    }`}
                    placeholder="Enter company name"
                    disabled={editingPartner?.status === "inactive"}
                    onChange={(e) => {
                      const trimmedValue = e.target.value.replace(/\s+/g, " ");
                      setValue("companyName", trimmedValue, {
                        shouldValidate: true,
                      });
                    }}
                    style={{
                      backgroundColor:
                        editingPartner?.status === "inactive" ? "#f8f9fa" : "",
                    }}
                  />
                  {errors.companyName && (
                    <span className="error-text">
                      {errors.companyName.message}
                    </span>
                  )}
                </div>

                <div className="form-group" style={{ position: "relative" }}>
                  <label>
                    Email <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Please enter a valid email address",
                      },
                    })}
                    type="email"
                    className={`form-input ${errors.email ? "error" : ""}`}
                    placeholder="Enter email"
                    disabled={
                      editingPartner?.status === "inactive" || editingPartner
                    }
                    style={{
                      backgroundColor:
                        editingPartner?.status === "inactive"
                          ? "#f8f9fa"
                          : "" || editingPartner
                            ? "#f8f9fa"
                            : "",
                      paddingRight: "35px",
                    }}
                  />
                  {editingPartner &&
                    (editingPartner.verified ? (
                      <MdVerified
                        className="position-absolute"
                        style={{
                          right: "5px",
                          top: "66%",
                          transform: "translateY(-50%)",
                          color: "#28a745",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        title="Email Verified"
                      />
                    ) : (
                      <GoUnverified
                        className="position-absolute"
                        style={{
                          right: "5px",
                          top: "66%",
                          transform: "translateY(-50%)",
                          color: "#dc3545",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        title="Email Not Verified"
                      />
                    ))}
                  {errors.email && (
                    <span className="error-text">{errors.email.message}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    {...register("firstName", {
                      required: "First name is required",
                      validate: (value) =>
                        value.trim() !== "" || "First name is required",
                    })}
                    className={`form-input ${errors.firstName ? "error" : ""}`}
                    placeholder="Enter first name"
                    disabled={editingPartner?.status === "inactive"}
                    style={{
                      backgroundColor:
                        editingPartner?.status === "inactive" ? "#f8f9fa" : "",
                    }}
                  />
                  {errors.firstName && (
                    <span className="error-text">
                      {errors.firstName.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>
                    Last Name <span className="text-danger">*</span>
                  </label>
                  <input
                    {...register("lastName", {
                      required: "Last name is required",
                      validate: (value) =>
                        value.trim() !== "" || "Last name is required",
                    })}
                    className={`form-input ${errors.lastName ? "error" : ""}`}
                    placeholder="Enter last name"
                    disabled={editingPartner?.status === "inactive"}
                    style={{
                      backgroundColor:
                        editingPartner?.status === "inactive" ? "#f8f9fa" : "",
                    }}
                  />
                  {errors.lastName && (
                    <span className="error-text">
                      {errors.lastName.message}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Country/Currency <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="country"
                    control={control}
                    rules={{ required: "Country is required" }}
                    render={({ field: { onChange, value, ...field } }) => (
                      <AsyncSelect
                        {...field}
                        value={
                          value
                            ? {
                                value,
                                label: `${value} (${
                                  watch("currency") || "USD"
                                })`,
                              }
                            : null
                        }
                        loadOptions={loadCountryOptions}
                        onChange={(selectedOption, action) => {
                          const result = handleCountryChange(
                            selectedOption,
                            action,
                          );
                          onChange(selectedOption?.value || "");
                        }}
                        placeholder="Search country..."
                        className={errors.country ? "error" : ""}
                        classNamePrefix="react-select"
                        isClearable
                        defaultOptions
                        noOptionsMessage={() => "No countries found"}
                        loadingMessage={() => "Loading countries..."}
                        isDisabled={editingPartner?.status === "inactive"}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "30px",
                            height: "30px",
                            backgroundColor:
                              editingPartner?.status === "inactive"
                                ? "#f8f9fa"
                                : base.backgroundColor,
                            border: errors.country
                              ? "1px solid #dc3545"
                              : "1px solid #ddd",
                            borderRadius: "4px",
                            "&:hover": {
                              border: errors.country
                                ? "1px solid #dc3545"
                                : "1px solid #ddd",
                            },
                          }),
                        }}
                      />
                    )}
                  />
                  <input {...register("currency")} type="hidden" />
                  {errors.country && (
                    <span className="error-text">{errors.country.message}</span>
                  )}
                </div>
                <div className="form-group" style={{ position: "relative" }}>
                  <label>
                    Contact Number <span className="text-danger">*</span>
                  </label>
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      border: errors.contactNumber
                        ? "1px solid #dc3545"
                        : "1px solid #ddd",
                      borderRadius: "4px",
                      height: "30px",
                      backgroundColor:
                        editingPartner?.status === "inactive"
                          ? "#f8f9fa"
                          : "#fff",
                    }}
                  >
                    <div
                      style={{ width: "100px", borderRight: "1px solid #ddd" }}
                    >
                      <AsyncSelect
                        value={{
                          value: phoneCountry,
                          label: (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {flagLink && (
                                <img
                                  src={`https://flagcdn.com/${flagLink?.toLowerCase()}.svg`}
                                  alt=""
                                  width={20}
                                  height={14}
                                  style={{
                                    objectFit: "cover",
                                    display: "block",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              )}
                              <span
                                style={{ fontSize: "13px", fontWeight: "500" }}
                              >
                                {countryCode}
                              </span>
                            </div>
                          ),
                        }}
                        loadOptions={loadCountryOptions}
                        onChange={handlePhoneCountryChange}
                        placeholder="Code"
                        classNamePrefix="react-select"
                        defaultOptions
                        noOptionsMessage={() => "No countries found"}
                        loadingMessage={() => "Loading countries..."}
                        isDisabled={editingPartner?.status === "inactive"}
                        formatOptionLabel={(option) => (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {option.isoCode && (
                              <img
                                src={`https://flagcdn.com/${option.isoCode?.toLowerCase()}.svg`}
                                alt=""
                                width={24}
                                height={16}
                                style={{ objectFit: "cover", display: "block" }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                }}
                              />
                            )}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {option.label}
                              </span>
                              <span style={{ fontSize: "12px", color: "#666" }}>
                                {option.countryCode}
                              </span>
                            </div>
                          </div>
                        )}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "28px",
                            height: "28px",
                            border: "none",
                            boxShadow: "none",
                            backgroundColor: "transparent",
                            borderRadius: "4px 0 0 4px",
                            "&:hover": {
                              border: "none",
                            },
                            "&.react-select__control--is-focused": {
                              border: "none",
                              boxShadow: "none",
                            },
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 4px",
                          }),
                          indicatorSeparator: () => ({ display: "none" }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: "0 4px",
                          }),
                          menu: (base) => ({
                            ...base,
                            width: "250px",
                          }),
                        }}
                      />
                    </div>
                    <input
                      {...register("contactNumber", {
                        required: "Contact number is required",
                        validate: (value) =>
                          validatePhoneNumber(value, phoneCountry),
                      })}
                      type="tel"
                      placeholder="Enter contact number"
                      maxLength={(() => {
                        const rules = getPhoneValidationRules(phoneCountry);
                        return rules.max;
                      })()}
                      onInput={(e) => {
                        let value = e.target.value.replace(/[^0-9]/g, "");
                        const rules = getPhoneValidationRules(phoneCountry);
                        if (value.length > rules.max) {
                          value = value.slice(0, rules.max);
                        }
                        e.target.value = value;
                        setValue("contactNumber", value);
                      }}
                      disabled={editingPartner?.status === "inactive"}
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        padding: "0 8px",
                        fontSize: "14px",
                        backgroundColor: "transparent",
                        borderRadius: "0 4px 4px 0",
                      }}
                    />
                  </div>
                  {errors.contactNumber && (
                    <span className="error-text">
                      {errors.contactNumber.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Logo</label>
                  <div className="file-input-wrapper d-flex align-items-center">
                    <div className="flex-grow-1 position-relative">
                      <input
                        type="file"
                        accept="image/*"
                        className="file-input"
                        id="logo-upload"
                        value=""
                        onChange={handleFileChange}
                        disabled={editingPartner?.status === "inactive"}
                        style={{
                          backgroundColor:
                            editingPartner?.status === "inactive"
                              ? "#f8f9fa"
                              : "",
                        }}
                      />
                      <label htmlFor="logo-upload" className="file-input-label">
                        <span>
                          {(() => {
                            const fileName =
                              selectedFileName ||
                              (editingPartner?.logo
                                ? editingPartner.logo.split("/").pop()
                                : "Upload Image");
                            return fileName.length > 22
                              ? fileName.substring(0, 22) + "..."
                              : fileName;
                          })()}
                        </span>
                        {!(selectedFile || editingPartner?.logo) && (
                          <FiUploadCloud className="upload-icon" />
                        )}
                      </label>

                      {/* Eye icon and clear button */}
                      {(selectedFile || editingPartner?.logo) && (
                        <>
                          <MdVisibility
                            className="info_pointer text-secondary text-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleLogoPreview();
                            }}
                            title="Preview Logo"
                            style={{
                              position: "absolute",
                              right: selectedFile ? "40px" : "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              fontSize: "22px",
                              background: "white",
                              padding: "4px",
                              borderRadius: "4px",
                            }}
                          />
                          {selectedFile && (
                            <CiCircleRemove
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedFile(null);
                                setSelectedFileName("");
                              }}
                              title="Remove Logo"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "16px",
                                color: "#dc3545",
                                cursor: "pointer",
                                background: "white",
                                borderRadius: "50%",
                              }}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    {...register("status", {
                      required: "Status is required",
                    })}
                    className={`form-input ${errors.status ? "error" : ""} ${
                      !editingPartner || editingPartner?.status === "inactive"
                        ? "disabled"
                        : ""
                    }`}
                    disabled={
                      !editingPartner || editingPartner?.status === "inactive"
                    }
                    value={editingPartner ? watch("status") : "active"}
                    style={{
                      backgroundColor:
                        !editingPartner || editingPartner?.status === "inactive"
                          ? "#f8f9fa"
                          : "",
                    }}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  {errors.status && (
                    <span className="error-text">{errors.status.message}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    License key <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="stripeLicenseKeyId"
                    control={control}
                    rules={{
                      required:
                        licensesList.length > 0 ? "License is required" : false,
                    }}
                    render={({ field: { onChange, value, ...field } }) => (
                      <AsyncSelect
                        {...field}
                        key={licensesList.length}
                        value={
                          value
                            ? (() => {
                                const selectedLicense = licensesList.find(
                                  (l) => l._id === value,
                                );
                                return selectedLicense
                                  ? {
                                      value: selectedLicense._id,
                                      label: selectedLicense.name,
                                    }
                                  : {
                                      value: value,
                                      label:
                                        editingPartner?.licenseId?.name ||
                                        editingPartner?.licenseName ||
                                        value,
                                    };
                              })()
                            : null
                        }
                        loadOptions={loadLicenseOptions}
                        onChange={(selectedOption, action) => {
                          handleLicenseChange(selectedOption, action);
                          onChange(selectedOption?.value || "");
                        }}
                        placeholder="Search licenses..."
                        className={errors.stripeLicenseKeyId ? "error" : ""}
                        classNamePrefix="react-select"
                        isClearable
                        defaultOptions={true}
                        isDisabled={!!editingPartner}
                        noOptionsMessage={() => "No licenses found"}
                        loadingMessage={() => "Loading licenses..."}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "30px",
                            height: "30px",
                            border: errors.stripeLicenseKeyId
                              ? "1px solid #dc3545"
                              : "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: editingPartner
                              ? "#f8f9fa"
                              : base.backgroundColor,
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.stripeLicenseKeyId && (
                    <span className="error-text">
                      {errors.stripeLicenseKeyId.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>
                    Domain Name <span>(Optional)</span>
                  </label>
                  <input
                    {...register("domainName")}
                    className={`form-input ${errors.domainName ? "error" : ""}`}
                    placeholder="Enter domain name (e.g., example.com)"
                    disabled={editingPartner?.status === "inactive"}
                    style={{
                      backgroundColor:
                        editingPartner?.status === "inactive" ? "#f8f9fa" : "",
                    }}
                  />
                </div>

                {editingPartner && (
                  <div className="form-group position-relative">
                    <label>Password</label>
                    <input
                      {...register("plainPassword")}
                      type="text"
                      className="form-input"
                      placeholder="Generated password"
                      style={{
                        backgroundColor:
                          editingPartner?.status === "inactive"
                            ? "#f8f9fa"
                            : "",
                      }}
                      readOnly
                    />
                    {editingPartner?.status === "active" && (
                      <MdRefresh
                        className="position-absolute"
                        style={{
                          right: "8px",
                          top: "66%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#007bff",
                          fontSize: "16px",
                          zIndex: 10,
                        }}
                        onClick={handlePasswordResetClick}
                        title="Reset password"
                      />
                    )}
                  </div>
                )}
                {editingPartner && (
                  <div className="form-group position-relative">
                    <label>OEM URL</label>
                    <div className="d-flex align-items-center">
                      <input
                        {...register("oemUrl")}
                        className={`form-input flex-grow-1 ${
                          editingPartner?.status === "inactive"
                            ? "disabled"
                            : ""
                        }`}
                        placeholder="OEM URL"
                        readOnly
                        style={{
                          backgroundColor: "#f8f9fa",
                          paddingRight: "40px",
                        }}
                      />
                      {/* {watch("oemUrl") && (
                        <MdContentCopy
                          className="position-absolute"
                          style={{
                            right: "8px",
                            top: "68%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: copiedUrl ? "#28a745" : "#007bff",
                            fontSize: "13px",
                            zIndex: 0,
                          }}
                          onClick={() => {
                            const text = watch("oemUrl");
                            if (
                              typeof navigator !== "undefined" &&
                              navigator.clipboard &&
                              window.isSecureContext
                            ) {
                              navigator.clipboard
                                .writeText(text)
                                .then(() => {
                                  setCopiedUrl(true);
                                  setTimeout(() => setCopiedUrl(false), 2000);
                                })
                                .catch(() => {
                                  // fallback
                                  const textArea =
                                    document.createElement("textarea");
                                  textArea.value = text;
                                  textArea.style.position = "fixed";
                                  document.body.appendChild(textArea);
                                  textArea.focus();
                                  textArea.select();
                                  document.execCommand("copy");
                                  document.body.removeChild(textArea);

                                  setCopiedUrl(true);
                                  setTimeout(() => setCopiedUrl(false), 2000);
                                });
                            } else {
                              // fallback always for http
                              const textArea =
                                document.createElement("textarea");
                              textArea.value = text;
                              textArea.style.position = "fixed";
                              document.body.appendChild(textArea);
                              textArea.focus();
                              textArea.select();
                              document.execCommand("copy");
                              document.body.removeChild(textArea);

                              setCopiedUrl(true);
                              setTimeout(() => setCopiedUrl(false), 2000);
                            }
                          }}
                          title={copiedUrl ? "Copied!" : "Copy URL"}
                        />
                      )} */}
                      {watch("oemUrl") && (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            marginLeft: "1px",
                          }}
                        >
                          {copiedUrl ? (
                            <LiaCheckDoubleSolid
                              className="position-absolute"
                              style={{
                                right: "8px",
                                top: "68%",
                                transform: "translateY(-50%)",
                                color: "#28a745",
                                fontSize: "16px",
                                zIndex: 0,
                              }}
                              title="Copied!"
                            />
                          ) : (
                            <MdContentCopy
                              className="position-absolute"
                              style={{
                                right: "8px",
                                top: "68%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#007bff",
                                fontSize: "13px",
                                zIndex: 0,
                              }}
                              onClick={() =>
                                handleCopyClick(
                                  watch("oemUrl"),
                                  "url",
                                  setCopiedUrl,
                                )
                              }
                              title="Copy URL"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="form-group col-4 mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <label>
                      Almata Shared Description
                      <span className="text-danger">*</span>
                      <span
                        className="text-secondary info_pointer cursor-pointer ms-1"
                        title="You can enter up to 50 words"
                      >
                        <FiInfo />
                      </span>
                    </label>
                  </div>
                  <div className="text-muted small mt-1">
                    Words: {descriptionWordCount}/50
                  </div>
                </div>

                <textarea
                  {...register("almataSharedDiscription", {
                    required: "Almata shared description is required",
                  })}
                  className={`form-input ${
                    errors.almataSharedDiscription ? "error" : ""
                  } ${editingPartner?.status === "inactive" ? "disabled" : ""}`}
                  placeholder="Enter OEM VOC...."
                  rows={4}
                  disabled={editingPartner?.status === "inactive"}
                  style={{
                    backgroundColor:
                      editingPartner?.status === "inactive" ? "#f8f9fa" : "",
                  }}
                  onChange={(e) => {
                    const words = e.target.value
                      .trim()
                      .split(/\s+/)
                      .filter((word) => word.length > 0);
                    setDescriptionWordCount(words.length);
                    // Clear validation error when user inputs valid data
                    if (e.target.value.trim()) {
                      clearErrors("almataSharedDiscription");
                    }
                  }}
                  onKeyDown={(e) => {
                    const currentText = e.target.value;
                    const words = currentText
                      .trim()
                      .split(/\s+/)
                      .filter((word) => word.length > 0);
                    if (
                      words.length >= 50 &&
                      e.key !== "Backspace" &&
                      e.key !== "Delete" &&
                      !e.key.includes("Arrow")
                    ) {
                      e.preventDefault();
                      toast.error("Maximum 50 words reached");
                    }
                  }}
                  onPaste={(e) => {
                    const currentText = e.target.value;
                    const pastedText = e.clipboardData.getData("text");
                    const combinedText = currentText + pastedText;
                    const words = combinedText
                      .trim()
                      .split(/\s+/)
                      .filter((word) => word.length > 0);
                    if (words.length > 50) {
                      e.preventDefault();
                      toast.error("Cannot paste - would exceed 50 word limit");
                    }
                  }}
                />
                {errors.almataSharedDiscription && (
                  <span className="error-text">
                    {errors.almataSharedDiscription.message}
                  </span>
                )}
              </div>

              <div className="form-actions">
                {editingPartner && (
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={() => {
                      setEditingPartner(null);
                      reset({
                        companyName: "",
                        email: "",
                        firstName: "",
                        lastName: "",
                        contactNumber: "",
                        logo: null,
                        country: "",
                        currency: "",
                        status: "active",
                        almataSharedDiscription: "",
                        stripeLicenseKeyId: "",
                        domainName: "",
                        stripeProductId: [""],
                        planDetails: [
                          {
                            stripeProductId: "",
                            amount: "",
                            planName: "",
                            couponDetails: "",
                          },
                        ],
                        oemUrl: "",
                      });
                      setSelectedFileName("");
                      setSelectedFile(null);
                      setStripeProductId([""]);
                      setPlanDetails([
                        {
                          stripeProductId: "",
                          amount: "",
                          planName: "",
                          couponDetails: "",
                        },
                      ]);
                    }}
                  >
                    Reset
                  </button>
                )}
                <button
                  type="submit"
                  className="add-btn"
                  disabled={
                    formLoading || editingPartner?.status === "inactive"
                  }
                >
                  {formLoading
                    ? "Processing..."
                    : editingPartner
                      ? "Update OEM"
                      : "Add OEM"}
                </button>
              </div>
            </form>
          </div>
        )}
        <OEMPartnerTable
          partners={partners}
          loading={loading}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          copiedId={copiedId}
          setCopiedId={setCopiedId}
          handleViewDetails={handleViewDetails}
          handleEditClick={handleEditClick}
          removePartner={removePartner}
          handleStatusChange={handleStatusChange}
          currentPage={currentPage}
          pagination={pagination}
          setCurrentPage={setCurrentPage}
        />
      </div>

      <DeleteConfirmModal
        isOpen={deleteModal.isOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        partnerName={deleteModal.partner?.companyName || ""}
      />

      <StatusConfirmModal
        isOpen={statusModal.isOpen}
        onClose={handleStatusCancel}
        onConfirm={handleStatusConfirm}
        partnerName={statusModal.partner?.companyName || ""}
        currentStatus={statusModal.partner?.status || ""}
        newStatus={statusModal.newStatus || ""}
      />

      <InactiveEditModal
        isOpen={inactiveEditModal.isOpen}
        onClose={handleInactiveEditClose}
        partnerName={inactiveEditModal.partner?.companyName || ""}
      />

      <OEMResetPasswordModal
        isOpen={passwordResetModal.isOpen}
        onClose={handlePasswordResetClose}
        onSave={handlePasswordResetSave}
        currentPassword={passwordResetModal.currentPassword}
        partnerId={editingPartner?._id}
        refreshParams={{
          limit: 10,
          page: currentPage,
          search: searchTerm,
          status: statusFilter,
          _id: itSalesPartnerId,
        }}
      />

      <LogoPreviewModal
        isOpen={logoPreviewModal.isOpen}
        onClose={handleLogoPreviewClose}
        imageUrl={logoPreviewModal.imageUrl}
        imageName={logoPreviewModal.imageName}
      />

      <OEMDetailsOffcanvas
        isOpen={detailsOffcanvas.isOpen}
        onClose={handleDetailsOffcanvasClose}
        partner={detailsOffcanvas.partner}
      />
      <CopyToast copiedId={copiedUrl ? "url" : null} />
    </div>
  );
};

export default OEMPartners;
